<template>
  <div id="surefahuo">
   <NavTop title='客户订单发货'/>
   <div class="orderitem">
    <div class="orderitem-line2" v-for="item in ordergoods" :key="item.id">
        <div class="orderitem-line2-col1"><img :src='item.headimg' class="goodsimg" /></div>
        <div class="orderitem-line2-col2">
              <div class="goodstitle">{{item.name}}</div>
              <div class="goodsparent">{{item.sellername}}</div>
              <div class="pricerow">
                   <div class="price">售价{{item.price}}</div>
                   <div class="nums">X{{item.nums}}</div>
              </div>
        </div>
    </div>
    <div class="orderitem-address">
      <div class="orderitem-address-col1">收件人信息:</div>
      <div class="orderitem-address-col2">
             <div class="recname">{{orderinfo.name}} {{orderinfo.mobile}}</div>
             <div class="addrinfo">{{orderinfo.province+orderinfo.city+orderinfo.county+orderinfo.address}}</div>
      </div>
    </div>
    <div class="orderitem-orderinfo">
      <div class="orderitem-orderinfo-line1">订单号:{{orderinfo.ordernum}}</div>
      <div class="orderitem-orderinfo-line2">
           <div class="orderitem-orderinfo-line2-col1">产生订单时间:{{orderinfo.date}}</div>
           <div class="orderitem-orderinfo-line2-col2">订货人:{{orderinfo.buyername}}</div>
      </div>
    </div>
    <div class="orderitem-logistic" >
       <div class="logistic-line1">
           <div class="chooseExpress"><input readonly :value="logistic_corp" @click="showLogistic=!showLogistic" /></div> 
           <div class="expressnumber"><input placeholder="请输入快递单号" v-model='logistic_nums'/></div>
       </div>
    </div>  
   </div>
   <div class="logistic-line2">
    <div class="logistic-surebtn" @click="doFahuo(orderinfo.id)">确认发货</div>
   </div>
   <van-popup v-model="showLogistic" round position="bottom">
      <van-picker
        title="选择快递公司"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showLogistic=false"
        />
    </van-popup>
  </div> 
</template>
<script>
import NavTop from '@/components/navtop'  
import {Picker,Popup } from 'vant'
export default {
  name: 'surefahuo',
  data(){
    return{
      orderinfo:{},
      ordergoods:[],
      showLogistic:false,
      columns: ['中通快递', '菜鸟快递', '韵达快递','顺丰快递', '圆通快递', '京东快递', '申通快递', '邮政EMS'],
      logistic_corp:'请选择快递公司',
      logistic_nums:'',
      processing:false
    }
  },
  created(){
     if(this.$route.params.orderid!=undefined){
         this.$post("/fahuo/getFahuoItem",{orderid:this.$route.params.orderid}).then((data)=>{
             if(data.result.success){
                this.orderinfo=data.result.info.orderinfo
                this.ordergoods=data.result.info.ordergoods
             }else{
                this.$toast(data.result.info)
             }
         })
     }
  },
  methods: {
     onConfirm(value){
        this.logistic_corp=value
        this.showLogistic=false
     },
     doFahuo(orderid){
        if(this.processing){
          this.$toast("请等待处理完成");return false;
        }
        if(this.logistic_corp=='请选择快递公司'||this.logistic_corp==""){
          this.$toast('请选择快递公司');return false;
        }
        if(this.logistic_nums==""){
          this.$toast('请输入快递单号');return false;
        }
        this.processing=true
        this.$post("/fahuo/doClientFahuo",{orderid:orderid,expresscorp:this.logistic_corp,expressnums:this.logistic_nums}).then((data)=>{
            this.processing=false
            if(data.result.success){
                this.$toast(data.result.info)
                setTimeout(()=>{this.$go("/fahuo")},1000)
            }else{
                this.$toast(data.result.info)
            }
        }) 
     }
  },
  components:{
    NavTop,
    [Picker.name]:Picker,
    [Popup.name]:Popup,
  }
}
</script>
<style scoped>
#surefahuo{display: flex;flex-flow: column nowrap;margin-bottom: 100px;padding: 0 0.25rem;}
.orderitem{display: flex;flex-flow: column nowrap;background-color: #fff;margin-bottom: 0.25rem;border-radius: 0.1rem;margin-top: 0.25rem;}
.orderitem-line1{display: flex;align-items: center;padding: 0.3rem;border-bottom: 1px solid #e7e7e7;}
.badge-red{font-size:0.3rem;border-radius: 0.1rem;border:1px solid #ff3600;color:#ff3600;padding: 0.05rem;}
.orderitem-line1-col2{font-size:0.33rem;padding: 0.1rem;padding-left: 0.3rem;}
.orderitem-line1-col3{margin-left: auto;}
.badge-grey{border:1px solid #999999;color:#999999;font-size: 0.3rem;padding: 0.1rem;border-radius: 0.1rem;}
.orderitem-line2{display: flex;border-bottom: 1px solid #e7e7e7;align-items: center;padding: 0.3rem;}
.goodsimg{width:2rem;height:2rem;}
.orderitem-line2-col2{display: flex;flex-flow: column nowrap;padding-left: 0.3rem;align-self: flex-start;width:100%;}
.goodstitle{font-size:0.33rem;color:#3c3c3c;text-align: left;}
.goodsparent{font-size:0.3rem;color:#ff3600;text-align: left;padding: 0.15rem 0;}
.pricerow{display: flex;margin-top: 0.1rem;}
.price{color:#5e5e5e;font-size:0.33rem;}
.nums{margin-left: auto;font-size:0.33rem;color:#5e5e5e}
.orderitem-line3{display: flex;padding: 0.33rem;}
.orderitem-line3-col2{margin-left: auto;}
.price-red{color:#ff3600;font-size:0.33rem}
.orderitem-address{display: flex;flex-flow: row nowrap;border-bottom: 1px solid #e7e7e7;}
.orderitem-address-col1{padding: 0.3rem;text-align: left;width:3rem;}
.orderitem-address-col2{display: flex;flex-flow: column nowrap;padding: 0.3rem;}
.orderitem-orderinfo{display: flex;flex-flow: column nowrap;padding: 0.3rem;border-bottom: 1px solid #e7e7e7;}
.orderitem-orderinfo-line2{display: flex;}
.orderitem-orderinfo-line1{text-align: left;font-size:0.33rem;margin-bottom: 0.2rem;}
.orderitem-orderinfo-line2-col1{font-size:0.33rem;}
.orderitem-orderinfo-line2-col2{margin-left: auto;font-size:0.33rem;}
.recname,.addrinfo{text-align: left;font-size:0.33rem}
.orderitem-btncon{padding: 0.3rem;}
.orderitem-btn{background: linear-gradient(to bottom,#ccc,#ddd);color:#333;height:1rem;width:2rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;margin-left:auto;}
.orderitem-logistic{display: flex;flex-flow: column nowrap;}
.logistic-line1{display: flex;padding: 0.3rem;}
.chooseExpress{width:3rem;}
.expressnumber input{font-size:0.33rem ; color:#333;}
.logistic-surebtn{width:100%;text-align: center;background-color:#ee0a24;color:#fff;padding: 0.25rem;border-radius: 0.1rem;}
.logistic-line2{margin-top:0.33rem;}
</style>


